export { default, type ServicesContentHeaderProps } from './ServicesContentHeader';
